export default "__VITE_ASSET__DaTr5xAN__"